(function($) {
	var $card = $( ".page-header-cta-card-container" ).first();

	// Stop the rest of the script if the content doesn't exist
	if( !$card.length ) return;

	var ajaxUrl			  = "/wp-admin/admin-ajax.php";
	var ipRegistryUrl = "https://api.ipregistry.co/?key=6149vez1a59igr";

	function escapeHtml( text ) {
		return $( "<div>" ).text( String( text || "" ) ).html();
	}

	function updateCard( locationData ) {
		// console.log( locationData );

		if( !locationData ) return;

		var locationImg   = String( locationData.image || "" ).trim();
		var locationName  = String( locationData.name || "" ).trim();
		var address1 		  = String( locationData.street || "" ).trim();
		var address2Parts = [];
		var phone 				= String( locationData.phone || "" ).trim();
		var city 					= String( locationData.city || "" ).trim();
		var state 				= String( locationData.state || "" ).trim();
		var zip 					= String( locationData.zip || "" ).trim();

		if( locationImg ) {
			$card.find( ".image-container" ).html( locationImg );
		}

		if( locationName ) {
			$card.find( ".location-name" ).html( locationName );
		}

		if( city )  address2Parts.push( city );
		if( state ) address2Parts.push( state );

		var address2 = address2Parts.join( ", " );

		if( zip ) address2 += ( address2 ? " " : "" ) + zip;

		if( address1 || address2 ) {
			$card.find( ".location-address" ).html(
				escapeHtml( address1 ) + ( address1 && address2 ? "<br />" : "") + escapeHtml( address2 )
			);
		}
		
		if( phone ) {
			$card.find( ".location-phone-placeholder" )
				.addClass( 'location-phone' )
				.text( phone )
				.attr( "href", "tel:" + phone )
				.show();
		}

		if( locationData.booking_url ) {
			var booking_utm = "?utm_source=website&utm_medium=localdaycare&utm_campaign=homepagewidget";

			$card.find( ".header-callout-card-book-btn" ).attr( 
				"href", locationData.booking_url + booking_utm 
			);
		}

		if( locationData.site_url ) {
			var local_utm = '/?utm_source=website&utm_medium=localdaycare&utm_campaign=daycarewebsitehomepagewidget&utm_term=local';

			$card.find( ".header-callout-location-url" ).attr( 
				"href", locationData.site_url + local_utm 
			);
		}

		$card.find( ".header-callout-card-book-btn" ).css( 'display', 'block' );

		if( typeof( Storage ) !== "undefined" ) {
			if( locationData.site_id ) {
				localStorage.setItem( "lastDogtopiaID", locationData.site_id );
			}

			if( locationData.name ) {
				localStorage.setItem( "lastDogtopiaName", locationData.name );
			}

			if( locationData.site_url ) {
				localStorage.setItem(
					"lastDogtopiaURL", String( locationData.site_url ).replace( /\/$/, "" )
				);
			}
		}
	}

	var storedSiteId = "";

	if( typeof( Storage ) !== "undefined" ) {
		storedSiteId = localStorage.getItem( "lastDogtopiaID" ) || "";
	}

	function fetchNearestLocationByLatLng( lat, lng ) {
		$.ajax( {
			url: ajaxUrl,
			type: "POST",
			dataType: "json",
			data: {
				action: "cta_card_get_nearest_location_by_latlng",
				lat: lat,
				lng: lng
			}
		} )
		.done( function( response ) {
			if( response && response.data ) {
				updateCard( response.data );
			}
		} )
		.fail( function( jqXHR, textStatus ) {
			console.log( "Request failed: " + textStatus );
			console.log( "jqXHR: " + jqXHR );
		} );
	}

	function fetchLocationFromIpRegistry() {
		$.getJSON( ipRegistryUrl, function( response ) {
			if( response.location.latitude && response.location.longitude ) {
				fetchNearestLocationByLatLng( response.location.latitude, response.location.longitude );
			}
		} );
	}

	if( storedSiteId && !isNaN( parseInt( storedSiteId, 10 ) ) ) {
		$.ajax( {
			url: ajaxUrl,
			type: "POST",
			dataType: "json",
			data: {
				action: "cta_card_get_location_by_subsite_id",
				site_id: storedSiteId
			}
		} )
		.done( function( response ) {
			if( response && response.data ) {
				updateCard( response.data );
			}
		} )
		.fail( function( jqXHR, textStatus ) {
  		console.log( "Request failed: " + textStatus );
  		console.log( "jqXHR: " + jqXHR );
		} );
	} 
	
	else {
		if( navigator.geolocation && typeof navigator.geolocation.getCurrentPosition === "function" ) {
			navigator.geolocation.getCurrentPosition(
				function( position ) {
					if( position && position.coords ) {
						fetchNearestLocationByLatLng( position.coords.latitude, position.coords.longitude );
						return;
					}

					fetchLocationFromIpRegistry();
				},
				
				function() {
					fetchLocationFromIpRegistry();
				},
				{
					enableHighAccuracy: false,
					timeout: 10000,
					maximumAge: 300000
				}
			);
		}
		
		else {
			fetchLocationFromIpRegistry();
		}
	}


	// dataLayer script
	function pushCtaCardEvent( action, details ) {
		window.dataLayer = window.dataLayer || [];

		var payload = {
			event: "header_callout_card_interaction",
			hcc_action: action,
		};

		if( details ) {
			$.extend( payload, details );
		}

		window.dataLayer.push( payload );
	}

	$( document ).on( "click", ".js-minimize-cta-toggle", function() {
		var isExpanded = $( this ).attr( "aria-expanded" ) === "true";

		pushCtaCardEvent( isExpanded ? "open_accordion" : "close_accordion" );
	} );

	$( document ).on( "click", ".header-callout-card-location-phone", function() {
		pushCtaCardEvent( "location_phone_click", {
			hcc_phone: $( this ).attr( "href" ) || ""
		} );
	} );

	$( document ).on( "click", ".header-callout-card-book-btn", function() {
		pushCtaCardEvent( "book_first_visit_click", {
			hcc_link: $( this ).attr( "href" ) || ""
		} );
	} );

	$( document ).on( "click", ".header-callout-location-url", function() {
		pushCtaCardEvent( "location_website_click", {
			hcc_link: $( this ).attr( "href" ) || ""
		} );
	} );

	$( document ).on( "click", ".header-callout-card-change-daycare-link", function() {
		pushCtaCardEvent( "change_daycare_click", {
			hcc_link: $( this ).attr( "href" ) || ""
		} );
	} );

	var hasScrolledPastCtaCard = false;

	function trackHomepageCtaScrollPast() {
		if( hasScrolledPastCtaCard || !$card.length ) return;

		var cardBottom = $card.offset().top + $card.outerHeight();
		var viewportTop = $( window ).scrollTop();

		if( viewportTop > cardBottom ) {
			hasScrolledPastCtaCard = true;
			pushCtaCardEvent( "scroll_past_header_callout_card" );
			$( window ).off( "scroll", trackHomepageCtaScrollPast );
		}
	}

	$( window ).on( "scroll", trackHomepageCtaScrollPast );
	trackHomepageCtaScrollPast();
} )( jQuery );
